import { Block, Text } from 'slate';
import BlockTypes from '../../../types/BlockTypes';
export default function documentShouldNotBeEmpty(node, editor, next) {
  if (node.object !== 'document') return next();
  if (!editor.value.document.nodes.isEmpty()) return next();
  editor.insertNodeByPath([], 0, Block.create({
    type: BlockTypes.UNSTYLED,
    nodes: [Text.create()]
  })).moveToStartOfDocument();
  return next();
}